import React from "react";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
  Legend,
} from "recharts";
import {
  RESULT_SUPPORT,
  RESULT_SUPPORT_AVG,
  RESULT_SUPPORT_COUNT,
} from "../../lib/results";
import { useTranslation } from "react-i18next";

export default function SupportSatisfactionChart() {
  const { t } = useTranslation();
  return (
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart
        data={RESULT_SUPPORT}
        margin={{
          top: 20,
          right: 20,
          bottom: 20,
          left: 20,
        }}
      >
        <CartesianGrid stroke="#f5f5f5" max={5} />
        <XAxis dataKey="name" />
        <YAxis
          dataKey="score"
          allowDecimals={false}
          domain={[0, 5]}
          ticks={[0, 1, 2, 3, 4, 5]}
        />
        <Tooltip />
        <Legend
          payload={[
            {
              value: t("SURVEYS_RESULT_DIALOG_SUPP_AVG", {
                avg: RESULT_SUPPORT_AVG,
              }),
              type: "line",
              color: "#ff7300",
            },
            {
              value: t("SURVEYS_RESULT_DIALOG_SUPP_COUNT", {
                count: RESULT_SUPPORT_COUNT,
              }),
              type: "line",
              color: "#6c3483",
            },
          ]}
        />
        <Bar dataKey="score" barSize={30} fill="#413ea0" />
        <ReferenceLine
          y={RESULT_SUPPORT_AVG}
          stroke="#ff7300"
          strokeDasharray="3 3"
          label=""
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
}
